module.exports = __webpack_public_path__ + "img/icon-close-mini.edb8e43a.svg";